export const TIMELINE_MARGIN_BREAKPOINTS = {
  lg: 260,
  tablet: 300,
  mobile: 360,
}

export const ICON_SLUGS_DICT: Record<string, string> = {
  'highlighted-freight': 'box',
  'highlithed-freight-extra': 'star',
  'register-gr': 'risk-management',
  'consult-gr': 'risk-management',
  'guep-consult-gr': 'risk-management',
  'consult-gr-free': 'risk-management',
  'freight-plus': 'box',
  'suggested-trucker': 'truck', 
  user: 'calendar'
}